{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "https://raw.githubusercontent.com/openwallet-foundation-labs/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
  "title": "WebhookConfig",
  "type": "object",
  "properties": {
    "auth": {
      "description": "Optional authentication configuration for the webhook.\nIf not provided, no authentication will be used.",
      "oneOf": [
        {
          "$ref": "./WebHookAuthConfigNone.schema.json"
        },
        {
          "$ref": "./WebHookAuthConfigHeader.schema.json"
        }
      ]
    },
    "url": {
      "type": "string",
      "description": "The URL to which the webhook will send notifications."
    }
  },
  "required": [
    "auth",
    "url"
  ]
}